import { render, staticRenderFns } from "./Col5.vue?vue&type=template&id=38807500&scoped=true"
import script from "./Col5.vue?vue&type=script&lang=js"
export * from "./Col5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38807500",
  null
  
)

export default component.exports